export default __webpack_public_path__ + "static/media/(35).12a743f0.jpg";